import { call, put } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import { inactiveSZLTFailed, inactiveSZLTSuccessful } from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest, { getBodyJson } from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { NO_CONTENT, OK } from '../../../configs/serverStatusCodes';
import { BACKEND_URL } from '../../../configs';

export default function* inactiveSZLT(action) {
  try {
    const { id, values } = action.payload;
    if (!id) { throw new Error('ID not found'); }
    const url = `${BACKEND_URL}/registries/order-services/${id}/inactive`;
    const response = yield makeRequest(url, values, action, 'POST', true);
    if (response.status === NO_CONTENT) {
      yield put(inactiveSZLTSuccessful());
      yield call(resolveActionPromise(action));
    } else {
      const data = yield getBodyJson(response);
      yield put(inactiveSZLTFailed());
      yield call(rejectActionPromise(action, data));
    }
  } catch (e) {
    yield put(inactiveSZLTFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
